import React, { useEffect } from "react";

export const STATUS_TOAST_DURATION_MS = 5_000;

export function StatusToast({
  message,
  onDismiss,
  action,
  persistent = false,
  durationMs = STATUS_TOAST_DURATION_MS,
}: {
  message: string;
  onDismiss: () => void;
  action?: {
    label: string;
    disabled?: boolean;
    onClick: () => void;
  };
  persistent?: boolean;
  durationMs?: number;
}) {
  useEffect(() => {
    if (!message || persistent) return;
    const timer = window.setTimeout(onDismiss, durationMs);
    return () => window.clearTimeout(timer);
  }, [durationMs, message, onDismiss, persistent]);

  if (!message) return null;

  return <div className="status-toast-region">
    <div className="status-toast" role="status" aria-live="polite" aria-atomic="true">
      <span>{message}</span>
      <div className="status-toast-actions">
        {action && <button
          className="primary-action"
          disabled={action.disabled}
          onClick={action.onClick}
        >{action.label}</button>}
        <button className="status-toast-dismiss" onClick={onDismiss} aria-label="Dismiss message">×</button>
      </div>
    </div>
  </div>;
}
